var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1158_112415)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1158_112415",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1158_112415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 16.6094H19.4219C17.8686 16.6094 16.6094 17.8686 16.6094 19.4219V23.0625M23.0625 16.6094C23.0625 17.79 22.5935 18.9221 21.7588 19.7568L19.7568 21.7588C18.9221 22.5935 17.79 23.0625 16.6094 23.0625M23.0625 16.6094V5.63203C23.0625 4.38699 22.5679 3.19289 21.6875 2.31249C20.8071 1.43213 19.613 0.937502 18.368 0.937502H5.63203C4.38698 0.937502 3.19289 1.43213 2.31248 2.31249C1.43213 3.19289 0.9375 4.38699 0.9375 5.63203V18.368C0.9375 19.613 1.43213 20.8071 2.31248 21.6875C3.19289 22.5679 4.38698 23.0625 5.63203 23.0625H15.6875H16.6094M6.46875 17.5313H12M6.46875 6.46875H17.5312M6.46875 12H17.5312",
    stroke: "#066D54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1158_112415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.882873f6.svg";
export { ForwardRef as ReactComponent };